import { render, staticRenderFns } from "./create.vue?vue&type=template&id=390d51d8"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390d51d8')) {
      api.createRecord('390d51d8', component.options)
    } else {
      api.reload('390d51d8', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=390d51d8", function () {
      api.rerender('390d51d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/organizations/create.vue"
export default component.exports